import { Directive, Input } from '@angular/core';
import { Observable, forkJoin, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { ToolsService } from '../services/ToolsService';

@Directive({
    selector: '[appOpenPdf]',
    host: {
        '(click)': 'openPdf()'
    },
    standalone: false
})
export class OpenPdfDirective {

  @Input() key: string;
  @Input() rounded = false;

  constructor(
    private readonly _toolsService: ToolsService,
    private readonly _notifyService: NzNotificationService,
  ) {}

  public openPdf(): void {
    this.openKey(this.key);
  }

  public openKey(key: string): void {
    this.openKey$(key).subscribe({
      error: () => this.notifyPdfError()
    });
  }

  public openKeys(keys: string[]): Observable<unknown> {
    const valid = keys.filter(Boolean);
    if (valid.length === 0) {
      return of(null);
    }

    return forkJoin(valid.map(key =>
      this.openKey$(key).pipe(
        catchError(() => {
          this.notifyPdfError();
          return of(null);
        })
      )
    ));
  }

  private openKey$(key: string): Observable<unknown> {
    if (!key) {
      return of(null);
    }

    return this._toolsService.getAmazonDownloadUrl(key).pipe(
      tap(data => {
        if (data?.link) {
          window.open(data.link, '_blank');
        }
      })
    );
  }

  private notifyPdfError(): void {
    this._notifyService.error('', 'PDF konnte nicht geöffnet werden.');
  }
}
